import { inject, Injectable } from '@angular/core';
import { utils, WorkBook, writeFile } from 'xlsx';
import { ExcelObject, UtilService } from './util.service';

@Injectable({
	providedIn: 'root',
})
export class ExcelService {
	private _util = inject(UtilService);
	constructor() {}

	downloadSimpleExcel(options: { tableQuerySelector?: string; filename?: string } = {}) {
		const dataObject: ExcelObject = { data: [], filename: '', extension: 'xlsx' };
		const { tableQuerySelector, filename } = options;

		const table = document.querySelector(tableQuerySelector || 'table');

		if (!table) {
			return;
		}
		dataObject.filename = this.getTitle(filename);

		const wb = utils.table_to_book(table, { sheet: dataObject.filename.slice(0, 31), cellStyles: true });

		this.downloadWorkBookToExcelFile(dataObject, wb);
	}

	downloadCustomExcel<T>(data: T[], options: { filename?: string; autoFilter?: boolean; sheetName?: string; rtl?: boolean } = {}) {
		const dataObject: ExcelObject = { data, filename: '', extension: 'xlsx' };

		const useAutoFilter = Boolean(options.autoFilter || false);
		const sheetName = options.sheetName ?? 'Sheet1';
		const useRTL = options.rtl || true;

		const wb = utils.book_new();

		const sheet = utils.json_to_sheet(dataObject.data);

		if (useAutoFilter) {
			const keys = Object.keys(data[0]);

			if (!keys.length) {
				throw Error('nothing to filter');
			}
			if (keys.length > 26) {
				throw Error('too many columns, current implementation only supports up to 26 columns');
			}
			const maxColumn = String.fromCharCode(Object.keys(data[0]).length + 64);

			sheet['!autofilter'] = { ref: `A1:${maxColumn}1` };
		}

		dataObject.filename = this.getTitle(options.filename);

		utils.book_append_sheet(wb, sheet, sheetName);

		this.downloadWorkBookToExcelFile(dataObject, wb, { useRTL });
	}

	private getTitle(filename?: string): string {
		let value = '';
		if (filename) {
			value = filename;
		} else {
			const title = document.querySelector('.header__title');
			value = title?.textContent || '';
		}
		return this._util.removeProblematicCharacters(value).trim();
	}

	private downloadWorkBookToExcelFile(dataObject: ExcelObject, wb: WorkBook, opts: { useRTL?: boolean } = { useRTL: true }) {
		const { useRTL } = opts;
		if (!wb.Workbook) wb.Workbook = {};
		if (!wb.Workbook.Views) wb.Workbook.Views = [{}];
		wb.Workbook.Views[0].RTL = useRTL;

		writeFile(wb, `${dataObject.filename}.${dataObject.extension}`, { bookType: dataObject.extension, compression: true, cellStyles: true });
	}
}
